var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowRight = function SvgLongArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 32,
    viewBox: "0 0 98 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.916 11.747 85.505.196c-.259-.261-.724-.261-1.033 0l-2.065 2.143c-.31.261-.31.732 0 1.046l9.035 9.094c.465.47.104 1.306-.568 1.306H.724a.71.71 0 0 0-.724.732v2.98c0 .417.31.731.723.731h90.15c.673 0 1.034.784.569 1.255l-9.035 9.146c-.259.261-.259.732 0 1.045l2.065 2.09a.74.74 0 0 0 1.084 0l11.36-11.497C97.586 19.534 98 18.593 98 17.6v-3.189c0-.992-.414-1.933-1.084-2.665"
  })));
};
export default SvgLongArrowRight;